var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48552 0H30.5145C35.7534 0 40 4.24665 40 9.4855V30.5145C40 35.7534 35.7534 40 30.5145 40H9.48552C4.24666 40 0 35.7534 0 30.5145V9.4855C0 4.24665 4.24666 0 9.48552 0Z",
    fill: "#3D599C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2655 7.63482L22.6191 7.55379C21.1846 7.5265 19.8004 8.06229 18.7636 9.07599C17.7267 10.0897 17.1562 11.4465 17.1562 12.8968V16.3555H13.7678C13.6281 16.3555 13.5156 16.4679 13.5156 16.6077V20.9544C13.5156 21.0933 13.6281 21.2066 13.7678 21.2066H17.1562V32.2035C17.1562 32.3432 17.2687 32.4557 17.4084 32.4557H21.8956C22.0354 32.4557 22.1478 32.3432 22.1478 32.2035V21.2066H25.5643C25.6908 21.2066 25.7983 21.1123 25.8149 20.9866L26.3796 16.6407C26.3887 16.5688 26.3672 16.4969 26.3192 16.4415C26.2713 16.3869 26.2018 16.3555 26.1299 16.3555H22.1487L22.1478 14.1578C22.147 14.147 22.0577 13.087 22.6109 12.4809C22.868 12.199 23.2194 12.0625 23.6841 12.0625H26.2622C26.4011 12.0625 26.5144 11.9501 26.5144 11.8104V7.887C26.5119 7.75057 26.4028 7.63812 26.2655 7.63482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e7919182a83fd37fff6c5dcce2cf92d3.svg";
export { ForwardRef as ReactComponent };